/**
 * @typedef {String} module:DeviceService.InvoiceTypes
 * @readonly
 * @description Types of invoices that services can have
 * @property {String} singleCamSub "SingleCamSub"
 * @property {String} prepay "Prepay"
 * @property {String} trial "Trial"
 * @property {String} comp "Comp"
 * @property {String} freeService "FreeService"
 * @property {String} voucher "Voucher"
 * @property {String} quota "Quota"
 * @property {String} unknown "Unknown"
 * @property {String} loadTest "LoadTest"
 * @property {String} featureFlag "FeatureFlag"
 * @property {String} main "Main"
 */
const InvoiceTypes = Object.freeze({
    main: 'Main',
    singleCamSub: 'SingleCamSub',
    prepay: 'Prepay',
    trial: 'Trial',
    comp: 'Comp',
    freeService: 'FreeService',
    voucher: 'Voucher',
    quota: 'Quota',
    unknown: 'Unknown',
    loadTest: 'LoadTest',
    featureFlag: 'FeatureFlag'
});

export default InvoiceTypes;
